import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SubmissionCommentFormState } from './SubmissionCommentFormState';
import { SubmissionCommentApis } from '../../../../apis/submissionComments';
import { SubmissionCommentTargetType } from '../../../../../commonv3/types/submission_comments';
import { translateErrorMessage } from '../../../../../commonv3/api/protocol';
import { SubmissionCommentIndexView } from '../../../../types/submission_comments';

export class SubmissionCommentListState {
  targetType = null;
  targetId = null;
  comments = RemoteResourceV3.loading();
  formState = new SubmissionCommentFormState();

  constructor() {
    makeObservable(this, {
      targetType: observable,
      targetId: observable,
      comments: observable,
      formState: observable,
      init: action.bound,
      create: action.bound,
    });
  }

  async init(targetType: SubmissionCommentTargetType, targetId: number) {
    this.targetType = targetType;
    this.targetId = targetId;
    await this.reload();
  }

  async reload() {
    await updateRemoteResourceV3(
      this.comments,
      (v) => (this.comments = v),
      () => SubmissionCommentApis.findAll(this.targetType, this.targetId)
    );
    this.formState.init();
  }

  async create(): Promise<SubmissionCommentIndexView | null> {
    await this.formState.validate();
    if (this.formState.hasErrors()) {
      return null;
    }
    return await this.formState.submitAsJson(async (value) => {
      try {
        const submission = await SubmissionCommentApis.create(this.targetType, this.targetId, value);
        if (submission) {
          await this.reload();
        }
        return submission;
      } catch (e) {
        alert('コメントの送信に失敗しました: ' + translateErrorMessage(e));
      }
    });
  }
}
